/**
 * Operations ▸ Port Calls metinleri (M13f; ADR 0052). Ekran adları İngilizce; Türkçe ikinci dil.
 */

const errorsEn = {
  GENERIC: 'The operation failed. Try again.',
  NETWORK: 'No connection. Check the network and try again.',
  FORBIDDEN: 'You are not allowed to do this.',
  NOT_FOUND: 'The port call was not found. It may have been removed.',
  VALIDATION_FAILED: 'Some fields are invalid.',
  ROW_VERSION_CONFLICT: 'Someone else changed this port call. Reopen it and try again.',
  INVALID_PORT_CALL: 'Some fields are invalid.',
  REQUIRED: 'Required.',
  TOO_LONG: 'Too long.',
  INVALID_DATETIME: 'Enter a valid date and time.',
  INVALID_TEXT: 'Invalid text.',
  INVALID_OPTION: 'Choose an option from the list.',
  INVALID_COUNTRY: 'Choose the country.',
  INVALID_EMAIL: 'Enter a valid e-mail address.',
  INVALID_PORT_CODE: 'The port code is invalid.',
  INVALID_TZ_OFFSET: 'Choose the time zone.',
  INVALID_ITINERARY_KEY: 'Choose a stop of the route.',
  ITINERARY_WITHOUT_VOYAGE: 'A route stop needs a voyage.',
  COUNTRY_MISMATCH: 'The country does not match the port.',
  ETD_BEFORE_ETA:
    'The Estimated Time of Departure (ETD) cannot be before the Estimated Time of Arrival (ETA).',
  ATD_WITHOUT_ATA:
    'Enter the Actual Time of Arrival (ATA) before the Actual Time of Departure (ATD).',
  ATD_BEFORE_ATA:
    'The Actual Time of Departure (ATD) cannot be before the Actual Time of Arrival (ATA).',
  DUPLICATE_ACTIVITY: 'An activity is selected twice.',
  FUTURE_DATE: 'An actual time cannot be in the future.',
  UNKNOWN_PORT: 'The port is not in the port list.',
  ITINERARY_UNKNOWN: 'The route stop is no longer in the route.',
  DUPLICATE_ITINERARY_CALL: 'This route stop already has a port call.',
  VESSEL_ALREADY_IN_PORT: 'The vessel is still in another port. Record its departure first.',
  VOYAGE_UNKNOWN: 'The voyage was not found on this vessel.',
  VOYAGE_CANCELLED: 'The voyage is cancelled.',
  CANNOT_CANCEL_ARRIVED: 'A port call cannot be cancelled after arrival.',
  CANCEL_REASON_REQUIRED: 'Enter the reason.',
  PORT_CALL_CANCELLED: 'The port call is cancelled and cannot change.',
  FILE_TOO_LARGE: 'A file is larger than 25 MB.',
  UNSUPPORTED_FILE_TYPE: 'Only PDF, JPG and PNG files can be attached.',
  SHIP_IS_WRITER: 'Port calls are recorded on board.',
};

const errorsTr: typeof errorsEn = {
  GENERIC: 'İşlem yapılamadı. Yeniden deneyin.',
  NETWORK: 'Bağlantı yok. Ağı kontrol edip yeniden deneyin.',
  FORBIDDEN: 'Bu işlem için yetkiniz yok.',
  NOT_FOUND: 'Liman ziyareti bulunamadı. Kaldırılmış olabilir.',
  VALIDATION_FAILED: 'Bazı alanlar geçersiz.',
  ROW_VERSION_CONFLICT: 'Bu kaydı başka biri değiştirdi. Yeniden açıp deneyin.',
  INVALID_PORT_CALL: 'Bazı alanlar geçersiz.',
  REQUIRED: 'Zorunlu.',
  TOO_LONG: 'Çok uzun.',
  INVALID_DATETIME: 'Geçerli bir tarih ve saat girin.',
  INVALID_TEXT: 'Geçersiz metin.',
  INVALID_OPTION: 'Listeden seçin.',
  INVALID_COUNTRY: 'Ülkeyi seçin.',
  INVALID_EMAIL: 'Geçerli bir e-posta adresi girin.',
  INVALID_PORT_CODE: 'Liman kodu geçersiz.',
  INVALID_TZ_OFFSET: 'Saat farkını seçin.',
  INVALID_ITINERARY_KEY: 'Güzergâhtan bir uğrak seçin.',
  ITINERARY_WITHOUT_VOYAGE: 'Güzergâh uğrağı için sefer gerekir.',
  COUNTRY_MISMATCH: 'Ülke limanla uyuşmuyor.',
  ETD_BEFORE_ETA: 'Tahmini Kalkış Zamanı (ETD), Tahmini Varış Zamanı’ndan (ETA) önce olamaz.',
  ATD_WITHOUT_ATA: 'Gerçek Kalkış Zamanı’ndan (ATD) önce Gerçek Varış Zamanı’nı (ATA) girin.',
  ATD_BEFORE_ATA: 'Gerçek Kalkış Zamanı (ATD), Gerçek Varış Zamanı’ndan (ATA) önce olamaz.',
  DUPLICATE_ACTIVITY: 'Bir faaliyet iki kez seçilmiş.',
  FUTURE_DATE: 'Gerçek zaman gelecekte olamaz.',
  UNKNOWN_PORT: 'Liman, liman listesinde yok.',
  ITINERARY_UNKNOWN: 'Bu uğrak artık güzergâhta değil.',
  DUPLICATE_ITINERARY_CALL: 'Bu uğrağın zaten bir liman ziyareti var.',
  VESSEL_ALREADY_IN_PORT: 'Gemi hâlâ başka bir limanda. Önce oradan kalkışı girin.',
  VOYAGE_UNKNOWN: 'Sefer bu gemide bulunamadı.',
  VOYAGE_CANCELLED: 'Sefer iptal edilmiş.',
  CANNOT_CANCEL_ARRIVED: 'Varıştan sonra liman ziyareti iptal edilemez.',
  CANCEL_REASON_REQUIRED: 'Gerekçeyi girin.',
  PORT_CALL_CANCELLED: 'Liman ziyareti iptal edilmiş; değiştirilemez.',
  FILE_TOO_LARGE: 'Bir dosya 25 MB’tan büyük.',
  UNSUPPORTED_FILE_TYPE: 'Yalnız PDF, JPG ve PNG dosyaları eklenebilir.',
  SHIP_IS_WRITER: 'Liman ziyaretleri gemide kaydedilir.',
};

export const portCallsEn = {
  list: {
    title: 'Port Calls',
    descriptionShip: 'Manage port calls, agents and port activities.',
    descriptionWeb: 'Port calls of the fleet, recorded on board.',
    new: 'New Port Call',
    filters: 'Port call filters',
    vessel: 'Vessel',
    allVessels: 'All Vessels',
    search: 'Search',
    searchPlaceholder: 'Search port, vessel, agent...',
    dateRange: 'Date Range',
    dateRangePlaceholder: 'local date of the call',
    dateFrom: 'From date',
    dateTo: 'To date',
    statusTabs: 'Status',
    table: 'Port Calls List',
    error: 'Port calls could not be loaded.',
    emptyTitle: 'No port calls yet',
    emptyShip: 'Select “New Port Call” to record the next call of the vessel.',
    emptyWeb: 'Port calls are recorded on board and appear here after synchronisation.',
    noMatch: 'No port call matches the filters.',
    open: 'Open port call {{port}}',
    estimated: 'estimated',
    showing: 'Showing {{from}}–{{to}} of {{total}}',
    pagination: 'Port calls pages',
    columns: {
      no: '#',
      date: 'Estimated Time of Arrival / Departure (ETA / ETD)',
      vessel: 'Vessel',
      port: 'Port / Harbour',
      country: 'Country',
      type: 'Type',
      activities: 'Activities',
      agent: 'Agent',
      duration: 'Duration',
      status: 'Status',
    },
  },
  tabs: {
    all: 'All',
    planned: 'Planned',
    ongoing: 'On Going',
    completed: 'Completed',
    cancelled: 'Cancelled',
  },
  statuses: {
    planned: 'Planned',
    ongoing: 'On Going',
    completed: 'Completed',
    cancelled: 'Cancelled',
  },
  units: { day: 'd', hour: 'h' },
  locationTypes: {
    berth: 'Berth',
    anchorage: 'Anchorage',
    buoy: 'Buoy',
    sts: 'STS',
    shipyard: 'Shipyard',
  },
  activities: {
    loading: 'Loading',
    discharging: 'Discharging',
    bunkering: 'Bunkering',
    fresh_water: 'Fresh Water',
    provisions: 'Provisions',
    stores: 'Stores',
    spares: 'Spares',
    crew_change: 'Crew Change',
    psc_inspection: 'PSC Inspection',
    flag_inspection: 'Flag Inspection',
    class_survey: 'Class Survey',
    vetting: 'Vetting',
    repairs: 'Repairs',
    waste_disposal: 'Waste Disposal',
    clearance: 'Clearance',
    canal_transit: 'Canal Transit',
    medical: 'Medical',
    other: 'Other',
  },
  fields: {
    vessel: 'Vessel',
    voyage: 'Voyage',
    routeStop: 'Route Stop',
    port: 'Port / Harbour',
    country: 'Country',
    locationType: 'Type',
    berth: 'Berth / Anchorage',
    timeZone: 'Time Zone',
    eta: 'Estimated Time of Arrival (ETA)',
    etd: 'Estimated Time of Departure (ETD)',
    ata: 'Actual Time of Arrival (ATA)',
    atd: 'Actual Time of Departure (ATD)',
    duration: 'Duration',
    agentName: 'Agent',
    agentContact: 'Contact Person',
    agentPhone: 'Phone',
    agentEmail: 'E-mail',
  },
  summary: {
    title: 'Port Call Summary',
    port: 'Port / Harbour',
    country: 'Country',
    etaEtd: 'Estimated Time of Arrival / Departure (ETA / ETD)',
    agent: 'Agent',
    activities: 'Activities',
    timeline: 'Port call times',
    localTime: 'Times are local:',
  },
  info: {
    ship: 'Port calls, agents and port activities are recorded here. The office sees them after synchronisation; documents are kept with the call.',
    web: 'Port calls are recorded on board. The office sees them read only, with their documents and change history.',
  },
  documents: {
    title: 'Related Documents',
    upload: 'Upload Document',
    loading: 'Loading documents...',
    none: 'No documents yet.',
    types: 'PDF, JPG or PNG, up to 25 MB. A document cannot be changed after upload.',
  },
  detail: {
    title: 'Port Call',
    description: 'Port call of {{vessel}}',
    error: 'The port call could not be loaded.',
    back: 'Back to list',
    edit: 'Edit',
    recordArrival: 'Record Arrival',
    recordDeparture: 'Record Departure',
    cancel: 'Cancel Port Call',
    cancelHint:
      'A planned port call that will not take place is cancelled with a reason. It stays in the list as “Cancelled”.',
    cancelReason: 'Reason',
    cancelConfirm: 'Cancel Port Call',
    cancelled: 'Port call cancelled.',
    cancelledNote: 'Cancelled: {{reason}}',
    arrivalSaved: 'Arrival recorded.',
    departureSaved: 'Departure recorded.',
    uploaded: '{{name}} uploaded.',
    details: 'Port Call Details',
    agent: 'Agent',
    activities: 'Port Activities',
    noActivities: 'No activities selected.',
    notes: 'Notes / Special Instructions',
    noNotes: 'No notes.',
    side: 'Summary and documents',
    noVoyage: 'No voyage',
    notInRoute: 'Not in route',
    extraCall: 'Extra call (not in route)',
  },
  form: {
    newTitle: 'New Port Call',
    editTitle: 'Edit Port Call',
    description: 'Times are entered in the local time of the port.',
    loadError: 'The form could not be loaded.',
    noVoyage: 'No voyage',
    extraCall: 'Extra call (not in route)',
    roles: { from: 'Departure', via: 'Port call', to: 'Arrival' },
    sections: {
      port: 'Voyage & Port',
      times: 'Times',
      agent: 'Agent',
      activities: 'Port Activities',
      notes: 'Notes / Special Instructions',
      documents: 'Documents',
    },
    berthPlaceholder: 'Terminal, berth or anchorage name',
    actualHint:
      'Enter the Actual Time of Arrival (ATA) and the Actual Time of Departure (ATD) when the vessel arrives and departs.',
    agentHint: 'Agents of earlier calls at this port are suggested.',
    notesPlaceholder: 'Fuel, water, logistics, spare parts delivery...',
    addFiles: 'Add Files',
    documentsHint:
      'Port clearance, agent confirmation, bunker receipt... PDF, JPG or PNG, up to 25 MB. Files are uploaded when the port call is saved.',
    removeFile: 'Remove {{name}}',
    preview: 'Port call preview',
    fixFields: 'Check the marked fields.',
    created: 'Port call saved.',
    updated: 'Port call updated.',
    savedWithFailedFiles: 'Port call saved, but these files could not be uploaded: {{files}}',
  },
  actions: { back: 'Cancel', save: 'Save' },
  errors: errorsEn,
};

export const portCallsTr: typeof portCallsEn = {
  list: {
    title: 'Liman Ziyaretleri',
    descriptionShip: 'Liman ziyaretlerini, acenteleri ve liman faaliyetlerini yönetin.',
    descriptionWeb: 'Filonun gemide kaydedilen liman ziyaretleri.',
    new: 'Yeni Liman Ziyareti',
    filters: 'Liman ziyareti süzgeçleri',
    vessel: 'Gemi',
    allVessels: 'Tüm Gemiler',
    search: 'Ara',
    searchPlaceholder: 'Liman, gemi, acente ara...',
    dateRange: 'Tarih Aralığı',
    dateRangePlaceholder: 'ziyaretin yerel tarihi',
    dateFrom: 'Başlangıç tarihi',
    dateTo: 'Bitiş tarihi',
    statusTabs: 'Durum',
    table: 'Liman Ziyaretleri Listesi',
    error: 'Liman ziyaretleri yüklenemedi.',
    emptyTitle: 'Henüz liman ziyareti yok',
    emptyShip: 'Geminin sıradaki ziyaretini kaydetmek için “Yeni Liman Ziyareti”ni seçin.',
    emptyWeb: 'Liman ziyaretleri gemide kaydedilir ve senkrondan sonra burada görünür.',
    noMatch: 'Süzgeçlere uyan liman ziyareti yok.',
    open: '{{port}} liman ziyaretini aç',
    estimated: 'tahmini',
    showing: '{{total}} kayıttan {{from}}–{{to}} gösteriliyor',
    pagination: 'Liman ziyaretleri sayfaları',
    columns: {
      no: '#',
      date: 'Tahmini Varış / Kalkış Zamanı (ETA / ETD)',
      vessel: 'Gemi',
      port: 'Liman',
      country: 'Ülke',
      type: 'Tür',
      activities: 'Faaliyetler',
      agent: 'Acente',
      duration: 'Süre',
      status: 'Durum',
    },
  },
  tabs: {
    all: 'Tümü',
    planned: 'Planlandı',
    ongoing: 'Devam Ediyor',
    completed: 'Tamamlandı',
    cancelled: 'İptal',
  },
  statuses: {
    planned: 'Planlandı',
    ongoing: 'Devam Ediyor',
    completed: 'Tamamlandı',
    cancelled: 'İptal',
  },
  units: { day: 'g', hour: 'sa' },
  locationTypes: {
    berth: 'Rıhtım',
    anchorage: 'Demir yeri',
    buoy: 'Şamandıra',
    sts: 'STS',
    shipyard: 'Tersane',
  },
  activities: {
    loading: 'Yükleme',
    discharging: 'Tahliye',
    bunkering: 'Yakıt ikmali',
    fresh_water: 'Tatlı su',
    provisions: 'Kumanya',
    stores: 'Malzeme',
    spares: 'Yedek parça',
    crew_change: 'Ekip değişimi',
    psc_inspection: 'PSC denetimi',
    flag_inspection: 'Bayrak denetimi',
    class_survey: 'Klas sörveyi',
    vetting: 'Vetting',
    repairs: 'Onarım',
    waste_disposal: 'Atık verme',
    clearance: 'Gümrük/Liman izni',
    canal_transit: 'Kanal geçişi',
    medical: 'Sağlık',
    other: 'Diğer',
  },
  fields: {
    vessel: 'Gemi',
    voyage: 'Sefer',
    routeStop: 'Güzergâh Uğrağı',
    port: 'Liman',
    country: 'Ülke',
    locationType: 'Tür',
    berth: 'Rıhtım / Demir Yeri',
    timeZone: 'Saat Farkı',
    eta: 'Tahmini Varış Zamanı (ETA)',
    etd: 'Tahmini Kalkış Zamanı (ETD)',
    ata: 'Gerçek Varış Zamanı (ATA)',
    atd: 'Gerçek Kalkış Zamanı (ATD)',
    duration: 'Süre',
    agentName: 'Acente',
    agentContact: 'İlgili Kişi',
    agentPhone: 'Telefon',
    agentEmail: 'E-posta',
  },
  summary: {
    title: 'Liman Ziyareti Özeti',
    port: 'Liman',
    country: 'Ülke',
    etaEtd: 'Tahmini Varış / Kalkış Zamanı (ETA / ETD)',
    agent: 'Acente',
    activities: 'Faaliyetler',
    timeline: 'Liman ziyareti zamanları',
    localTime: 'Zamanlar yerel saattir:',
  },
  info: {
    ship: 'Liman ziyaretleri, acenteler ve liman faaliyetleri burada kaydedilir. Ofis senkrondan sonra görür; belgeler ziyaretle birlikte saklanır.',
    web: 'Liman ziyaretleri gemide kaydedilir. Ofis belgeleri ve değişiklik geçmişiyle birlikte salt okunur görür.',
  },
  documents: {
    title: 'İlgili Belgeler',
    upload: 'Belge Yükle',
    loading: 'Belgeler yükleniyor...',
    none: 'Henüz belge yok.',
    types: 'PDF, JPG ya da PNG, en çok 25 MB. Yüklenen belge değiştirilemez.',
  },
  detail: {
    title: 'Liman Ziyareti',
    description: '{{vessel}} liman ziyareti',
    error: 'Liman ziyareti yüklenemedi.',
    back: 'Listeye dön',
    edit: 'Düzelt',
    recordArrival: 'Varışı Kaydet',
    recordDeparture: 'Kalkışı Kaydet',
    cancel: 'Liman Ziyaretini İptal Et',
    cancelHint:
      'Gerçekleşmeyecek planlı ziyaret gerekçeyle iptal edilir; listede “İptal” olarak kalır.',
    cancelReason: 'Gerekçe',
    cancelConfirm: 'İptal Et',
    cancelled: 'Liman ziyareti iptal edildi.',
    cancelledNote: 'İptal edildi: {{reason}}',
    arrivalSaved: 'Varış kaydedildi.',
    departureSaved: 'Kalkış kaydedildi.',
    uploaded: '{{name}} yüklendi.',
    details: 'Liman Ziyareti Bilgileri',
    agent: 'Acente',
    activities: 'Liman Faaliyetleri',
    noActivities: 'Faaliyet seçilmemiş.',
    notes: 'Notlar / Özel Talimatlar',
    noNotes: 'Not yok.',
    side: 'Özet ve belgeler',
    noVoyage: 'Sefer yok',
    notInRoute: 'Güzergâhta değil',
    extraCall: 'Ek uğrak (güzergâh dışı)',
  },
  form: {
    newTitle: 'Yeni Liman Ziyareti',
    editTitle: 'Liman Ziyaretini Düzelt',
    description: 'Zamanlar limanın yerel saatiyle girilir.',
    loadError: 'Form yüklenemedi.',
    noVoyage: 'Sefer yok',
    extraCall: 'Ek uğrak (güzergâh dışı)',
    roles: { from: 'Kalkış', via: 'Uğrak', to: 'Varış' },
    sections: {
      port: 'Sefer ve Liman',
      times: 'Zamanlar',
      agent: 'Acente',
      activities: 'Liman Faaliyetleri',
      notes: 'Notlar / Özel Talimatlar',
      documents: 'Belgeler',
    },
    berthPlaceholder: 'Terminal, rıhtım ya da demir yeri adı',
    actualHint:
      'Gemi varınca Gerçek Varış Zamanı’nı (ATA), kalkınca Gerçek Kalkış Zamanı’nı (ATD) girin.',
    agentHint: 'Bu limandaki önceki ziyaretlerin acenteleri önerilir.',
    notesPlaceholder: 'Yakıt, su, lojistik, yedek parça teslimi...',
    addFiles: 'Dosya Ekle',
    documentsHint:
      'Liman izni, acente teyidi, yakıt makbuzu... PDF, JPG ya da PNG, en çok 25 MB. Dosyalar liman ziyareti kaydedilince yüklenir.',
    removeFile: '{{name}} dosyasını çıkar',
    preview: 'Liman ziyareti önizlemesi',
    fixFields: 'İşaretli alanları kontrol edin.',
    created: 'Liman ziyareti kaydedildi.',
    updated: 'Liman ziyareti güncellendi.',
    savedWithFailedFiles: 'Liman ziyareti kaydedildi; şu dosyalar yüklenemedi: {{files}}',
  },
  actions: { back: 'Vazgeç', save: 'Kaydet' },
  errors: errorsTr,
};
